import { FormMode } from '../../controls/common/form-mode';
import { IRestApiConfiguration } from 'src/app/models/RestApiCaller/Interfaces/rest-api-configuration.interface';

export class ApiConfigurationFormContext {
    /**
     * Instance de la configuration de l'API REST affichée dans le formulaire.
     */
    public restApiConfiguration: IRestApiConfiguration;

    /**
     * Indique si le formulaire est visible (true) ou pas (false).
     */
    public formVisible = false;

    public mode: FormMode = FormMode.Reading;
}
